<h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="associativaForm">
<form [formGroup]="associativaForm" (ngSubmit)="update();">
	<div class="row" *ngIf="inserimento && parte && parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
		<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Cognome/Nome'"
			[valueInput]="parte.nominativo"></div>
		<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Tipo persona'" [valueInput]="parte.tipoPersona?.label"></div>
		<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Matricola'" [valueInput]="parte.matricola"></div>
		<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Codice fiscale'" [valueInput]="parte.codiceFiscale"></div>
	</div>
	<div class="row" *ngIf="inserimento && parte && parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Ragione sociale'"
			[valueInput]="parte.ragioneSociale"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Tipo persona'" [valueInput]="parte.tipoPersona?.label"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Partita iva'" [valueInput]="parte.partitaIva"></div>
	</div>
	<div class="row">

		<div comboModInput [ngClass] ="{'component-suggested': this.suggestedCategory}"
         class="col-sm-4" [labelInput]="'Categoria'"
         formControlName="categoria"
         [control]="associativaForm.controls['categoria']"
         [optionsCombo] ="tipicategoriaOptions"
         [objectReference]="controparte.categoria"
         [ngModel]="controparte.categoria"
         (onReturn)="controparte.categoria = $event"
         [mandatory]="false"></div>

		<!--<div datePickerInput [mandatory]="true"
			[control]="associativaForm.controls['dataAssociazione']"
			class="col-sm-4" [labelInput]="'Data associazione'" [dataAl]="controparte.dataTermine"
			formControlName="dataAssociazione"
			[(ngModel)]="controparte.dataAssociazione"></div>-->
		<div checkBoxRadio
		    [submitPending]="primariaPreselected"
			class="col-sm-4" [labelInput]="'Primaria'" [idInput]="inserimento ? 'primario-ins' + position : 'primario-mod' + position"
			formControlName="primario"
			[objectReference]="controparte.primario"
			(onReturn)="controparte.primario = $event"></div>
		<div checkBoxRadio [ngClass] ="{'component-suggested': this.suggestedSubjectType && this.flagAttore,
     'component-suggested-unchecked': this.suggestedSubjectType && !this.flagAttore}"
        class="col-sm-4"
			  [idInput]="inserimento ? 'tipoSogg-ins' + position : 'tipoSogg-mod' + position"
        [control]="associativaForm.controls['flagAttore']"
        [ngModel]="controparte.flagAttore"
			  [labelNotChecked]="'Convenuto'"
			  [labelChecked]= "'Attore'"
        [labelInput]="'Tipo soggetto'"
        formControlName="flagAttore" [objectReference]="controparte.flagAttore"
        (onReturn)="controparte.flagAttore = $event;changeFlag()"></div>
			<!--<div checkBoxRadio class="col-sm-2" [labelInput]="'Cliente'"
      [idInput]="inserimento ? 'cliente-ins' : 'cliente-mod'" formControlName="cliente"
			[objectReference]="controparte.cliente"
			[control]="associativaForm.controls['cliente']"
			(onReturn)="controparte.cliente = $event"></div>-->
	</div>

	<div class="row">
		<div checkBoxRadio class="col-sm-4" [labelInput]="'Rinunciatario'"
      		[idInput]="inserimento ? 'ritirato-ins' + position : 'ritirato-mod' + position" formControlName="ritirato"
			[control]="associativaForm.controls['ritirato']"
			[objectReference]="controparte.ritirato"
			(change)="controparte.dataTermine=undefined;"
			(onReturn)="controparte.ritirato = $event"></div>
		<div datePickerInput class="col-sm-4" [labelInput]="'Data rinuncia'"
			[submitPending]="!controparte.ritirato"
			formControlName="dataTermine"
			[(ngModel)]="controparte.dataTermine"
			[mandatory]="!!controparte.ritirato">
		</div>
	</div>

	<div class="row">
		<div textAreaInput class="col-sm-12" [labelInput]="'Note'"
			formControlName="note" [(ngModel)]="controparte.note"></div>
	</div>
	<div class="row">
		<p class="mandatory col-sm-12">
			<em>* Campi obbligatori</em>
		</p>
	</div>
	<div class="row">
		<p class="col-sm-3 col-xs-6">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="createForm();">Reset</button>
		</p>
		<p submitButton [disabled]="!associativaForm.valid || (controparte.ritirato && !controparte.dataTermine)"
			class="col-sm-3 col-xs-6 col-sm-offset-6"
			[labelButton]="'Completa associazione'">
			<!-- 				<button type="button" class="btn btn-primary btn-block" (click)="update();">Salva</button> -->
		</p>

	</div>
</form>
</ng-template>
